export const users = [
  { email: "mohamed@instabug.com", password: "A12345678" },
  { email: "mohamed1@instabug.com", password: "A12345678" },
  { email: "mohamed3@instabug.com", password: "A12345678" },
  { email: "mohamed4@instabug.com", password: "A12345678" },
  { email: "mohamed2@instabug.com", password: "A12345678" },
  { email: "mohamed5@instabug.com", password: "A12345678" },
  { email: "mohamed6@instabug.com", password: "A12345678" },
  { email: "mohamed7@instabug.com", password: "A12345678" },
];

export const slideText = [
  "Accelerate Your Entire Mobile Team Workflow",
  "The Most Comprehensive Bug Reporting Tool for Mobile Apps",
  "Secure Crash Reporting With Real-Time Alerts",
];
export const slideImages = [
  "https://svgshare.com/i/hrA.svg",
  "https://svgshare.com/i/hrB.svg",
  "https://svgshare.com/i/hrV.svg",
];
